/**
 * =====================================================
 * AVA CLIENT - NotFound V4
 * =====================================================
 * 404 page with V4 unified design.
 * =====================================================
 */
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, Home, Shield } from "lucide-react";
import { useLocation } from "wouter";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50/50">
      <Card className="w-full max-w-lg mx-4 border-0 shadow-sm bg-white">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-2xl bg-red-50 flex items-center justify-center">
              <AlertCircle className="h-10 w-10 text-red-500" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-2">404</h1>
          <h2 className="text-xl font-semibold text-foreground mb-4">
            Página no encontrada
          </h2>
          <p className="text-muted-foreground mb-8 leading-relaxed">
            La página que buscás no existe o fue movida.
          </p>
          <div
            id="not-found-button-group"
            className="flex flex-col sm:flex-row gap-3 justify-center"
          >
            <Button
              onClick={() => setLocation("/")}
              className="h-11 px-6 font-semibold"
            >
              <Home className="w-4 h-4 mr-2" />
              Volver al inicio
            </Button>
          </div>
          <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground mt-8">
            <Shield className="w-3 h-3" />
            <span>AVA Onboarding & Compliance</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
